import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./ContactRequest.css";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { RxReload } from "react-icons/rx";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import AdminHeader from "../../../components/CommonComponents/AdminHeader";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import BootstrapTable from "react-bootstrap-table-next";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { donwloadCSV, videodownloadPDF, videodownloadXLSX } from "../../../components/CommonMethod/CommonMethods";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";

function ContactRequest() {
  const { fetchRequest } = useMyContext()
  const [contactrequest, setContactrequest] = useState([]);
  const [loading, setLoading] = useState(true);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [filteredData, setFilteredData] = useState([]);
  const [reloading, setReLoading] = useState(false);


  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    }]
  });

  const BaseUrl = process.env.REACT_APP_Baseurl
  const listApi = `${BaseUrl}/admin/contact-us`

  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const fetchData = async (type) => {
    try {
      setLoading(true);

      const response = await fetchRequest({
        method: 'GET',
        url: `${listApi}`,
        params: {},
        data: {},
      });

      const result = response;
      const updatedList = result?.data || [];
      const exportData = updatedList.map((item, index) => ({
        "S.NO": index + 1,
        "NAME": item?.fullname,
        "E-MAIL": item?.email,
        "MOBILE": item?.phone_number,
        "SUBJECT": item?.subject,
        "MESSAGE": item?.message,
      }));

      if (type === "CSV") {
        await donwloadCSV(exportData, "CONTACT-LIST");
      } else if (type === "PDF") {
        await videodownloadPDF(exportData, "CONTACT-LIST", [
          "S.NO", "NAME", "E-MAIL", "MOBILE", "SUBJECT", "MESSAGE"
        ]);
      } else if (type === "XLSX") {
        await videodownloadXLSX(exportData, "CONTACT-LIST", [
          "S.NO", "NAME", "E-MAIL", "MOBILE", "SUBJECT", "MESSAGE"
        ]);
      }
      setContactrequest(updatedList);
      setFilteredData(updatedList);
    } catch (error) {
      console.error("Fetch data error:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [withOutRefresh]);

  const reloadAction = async () => {
    setReLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    // try {
    //   const response = await axios.get(listApi, {
    //     headers: headers,
    //   });

    // } catch (error) {
    //   console.error("Error fetching data:", error);
    // } finally {
    setReLoading(false);
    // }
  };

  const columns = [
    {
      dataField: "fullname",
      text: "Name",
      formatter: (cell, row) => {
        return <div className="text-center">{cell}</div>;
      },
    },
    {
      dataField: "email",
      text: "Email",
      formatter: (cell, row) => {
        return <div className="text-center">{cell}</div>;
      },
    },
    {
      dataField: "phone_number",
      text: "Mobile",
      formatter: (cell, row) => {
        return <div className="text-center">{cell}</div>;
      },
    },
    {
      dataField: "subject",
      text: "Subject",
      formatter: (cell, row) => {
        return <div className="text-center">{cell}</div>;
      },
    },
    {
      dataField: "message",
      text: "Message",
      formatter: (cell, row) => {
        return <div className="text-center">{cell}</div>;
      },
    },
    {
      dataField: "attach_screenshot",
      text: "Attach Screenshot",
      formatter: (cell, row) => {
        return (
          <div className="text-center">
            <img src={cell} alt="screenshot" style={{ width: "50px", height: "50px" }} />
          </div>
        );
      },
    }
  ];

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();

    if (!value) {
      setFilteredData(contactrequest);
      return;
    }

    const filtered = contactrequest.filter(item =>
      item.fullname?.toLowerCase().includes(value) ||
      item.email?.toLowerCase().includes(value) ||
      item.phone_number?.toLowerCase().includes(value) ||
      item.screenshot?.toLowerCase().includes(value) ||
      item.subject?.toLowerCase().includes(value) ||
      item.message?.toLowerCase().includes(value)
    );

    setFilteredData(filtered);
  };

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "All", value: filteredData.length },
    ],
  });

  return (
    <div className=" m-0 p-0">

      {reloading && (
        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.6)',
          display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10,
        }}><Defaultloadinggif />
        </div>
      )}

      <div className="theme-bg-color p-3 rounded-2 bootstrapTable" >
        <AdminNavbar heading={"Contact Us"} totalDataLength={filteredData?.length} />
        <div className='theme-bg-color p-3 rounded-3 mb-5'>
          <div className='d-flex align-items-center flex-wrap justify-content-between  mb-3'>
            <div className="filterContainer">
              <input type='text' placeholder="Search" className="filter form-control theme-text-color theme-border-secondary theme-bg-color-secondary" onChange={handleSearch} />
            </div>

            <div className=' d-flex align-items-center'>

              <button className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color `} onClick={reloadAction}>
                <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                <AdminTooltip  text="Refresh"  top={"-41px"} className="d-none custom-tool-tip" />

              </button>

              <div className="dropdown d-block ms-2 " key={"2"}>
                <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"  >
                  <span className="fw-bolder text-white">Export all</span>
                  <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                </button>
                <ul className="dropdown-menu theme-bg-color" aria-labelledby="dropdownMenuButton1" >
                  <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("CSV", "ALL")}>CSV</li>
                  <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("PDF", "ALL")}>PDF</li>
                  <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("XLSX", "ALL")}>XLSX </li>
                </ul>
              </div>

            </div>
          </div>
          <BootstrapTable keyField="id" pagination={pagination} columns={columns} data={filteredData} className="no-border-table theme-text-color " noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover headerClasses="videoWidth" />
        </div>
      </div>
    </div>
  );
}

export default ContactRequest;